export {default} from './Pill';
export {PILL_HEIGHT} from './Pill.style';
